import { ExportProfile, Id, QueryParams } from "PFTypes";

import api from "../api/api";

export type ExportProfilesQueryParams = QueryParams & { profileIds?: Id[]; activityId?: Id };
export type ExportProfilesResponse = Partial<ExportProfile>[];

export const fetchExportProfiles = (data: ExportProfilesQueryParams) =>
  api<ExportProfilesResponse>({ url: "export/profiles/index", method: "POST", data });
